export const parseFileUrl = (path?: string) => {
    const filePaths = path?.replace(/(^\w+:|^)\/\//, '').split('/');
    const fileRelativePath = filePaths?.slice(0, -1).join('/');
    const fileFullName = filePaths?.slice(-1)[0];
    const fileExtension = fileFullName?.split('.').slice(-1)[0];
    const fileName = fileFullName?.split('.').slice(0, -1).join('.');

    return { fileFullName, fileRelativePath, fileName, fileExtension };
};
